export const SEPERATOR_OPTIONS = [
  {
    displayvalue: 0, displayname: '-', name: 'hyphen', key: 'SignHyphen',
  },
  {
    displayvalue: 1, displayname: '/', name: 'forward slash', key: 'SignForwardSlash',
  },
  {
    displayvalue: 2, displayname: '\\', name: 'backward slash', key: 'SignBackwardSlash',
  },
  {
    displayvalue: 3, displayname: '_', name: 'underscore', key: 'SignUnderscore',
  },
  {
    displayvalue: 4, displayname: '', name: 'no separator', key: 'SignNOSeparator',
  },
];

export const LIST = [
  [
    // {
    //   displayvalue: 0,
    //   displayname: "",
    //   key: "LbHide",
    //   isSelected: false,
    //   name: "",
    //   textValue: "",
    //   key2: "LbHide2"
    // },
    {
      displayvalue: 1,
      displayname: 'Company name',
      key: 'LbCompanyName',
      isSelected: false,
      name: 'a1',
      textValue: '',
      key2: 'LbFirst',
      key2name: 'First',
    },
    {
      displayvalue: 2,
      displayname: 'Business unit name',
      key: 'LbUnitName',
      isSelected: false,
      name: 'a2',
      textValue: '',
      key2: 'LbFirst',
      key2name: 'First',
    },
    {
      displayvalue: 3,
      displayname: 'Office location name',
      key: 'LbLocationName',
      isSelected: false,
      name: 'a3',
      textValue: '',
      key2: 'LbFirst',
      key2name: 'First',
    },
    {
      displayvalue: 4,
      displayname: 'Department name ',
      key: 'LbDepartmentName',
      isSelected: false,
      name: 'a4',
      textValue: '',
      key2: 'LbFirst',
      key2name: 'First',
    },
    {
      displayvalue: 5,
      displayname: 'Custom text',
      key: 'LbCustomText',
      isSelected: false,
      name: 'a5',
      textValue: '',
      key2: 'LbUse',
      key2name: 'Use',
    },
    {
      displayvalue: 6,
      displayname: 'Numerical series starting from',
      key: 'LbNumericalSeries',
      isSelected: false,
      name: 'a6',
      textValue: '',
      key2: 'a',
      key2name: 'a',
    },
  ],
  [
    // {
    //   displayvalue: 0,
    //   displayname: "",
    //   key: "LbHide",
    //   isSelected: false,
    //   name: "",
    //   textValue: "",
    //   key2: "LbHide2"
    // },
    {
      displayvalue: 1,
      displayname: 'Company name',
      key: 'LbCompanyName',
      isSelected: false,
      name: 'b1',
      textValue: '',
      key2: 'LbFirst',
      key2name: 'First',
    },
    {
      displayvalue: 2,
      displayname: 'Business unit name',
      key: 'LbUnitName',
      isSelected: false,
      name: 'b2',
      textValue: '',
      key2: 'LbFirst',
      key2name: 'First',
    },
    {
      displayvalue: 3,
      displayname: 'Office location name',
      key: 'LbLocationName',
      isSelected: false,
      name: 'b3',
      textValue: '',
      key2: 'LbFirst',
      key2name: 'First',
    },
    {
      displayvalue: 4,
      displayname: 'Department name ',
      key: 'LbDepartmentName',
      isSelected: false,
      name: 'b4',
      textValue: '',
      key2: 'LbFirst',
      key2name: 'First',
    },
    {
      displayvalue: 5,
      displayname: 'Custom text',
      key: 'LbCustomText',
      isSelected: false,
      name: 'a5',
      textValue: '',
      key2: 'LbUse',
      key2name: 'Use',
    },
    {
      displayvalue: 6,
      displayname: 'Numerical series starting from',
      key: 'LbNumericalSeries',
      isSelected: false,
      name: 'a6',
      textValue: '',
      key2: 'a',
      key2name: 'a',
    },
  ],
  [
    // {
    //   displayvalue: 0,
    //   displayname: "",
    //   key: "LbHide",
    //   isSelected: false,
    //   name: "",
    //   textValue: "",
    //   key2: "LbHide2"
    // },
    {
      displayvalue: 1,
      displayname: 'Company name',
      key: 'LbCompanyName',
      isSelected: false,
      name: 'c1',
      textValue: '',
      key2: 'LbFirst',
      key2name: 'First',
    },
    {
      displayvalue: 2,
      displayname: 'Business unit name',
      key: 'LbUnitName',
      isSelected: false,
      name: 'c1',
      textValue: '',
      key2: 'LbFirst',
      key2name: 'First',
    },
    {
      displayvalue: 3,
      displayname: 'Office location name',
      key: 'LbLocationName',
      isSelected: false,
      name: 'c1',
      textValue: '',
      key2: 'LbFirst',
      key2name: 'First',
    },
    {
      displayvalue: 4,
      displayname: 'Department name ',
      key: 'LbDepartmentName',
      isSelected: false,
      name: 'c1',
      textValue: '',
      key2: 'LbFirst',
      key2name: 'First',
    },
    {
      displayvalue: 5,
      displayname: 'Custom text',
      key: 'LbCustomText',
      isSelected: false,
      name: 'a5',
      textValue: '',
      key2: 'LbUse',
      key2name: 'Use',
    },
    {
      displayvalue: 6,
      displayname: 'Numerical series starting from',
      key: 'LbNumericalSeries',
      isSelected: false,
      name: 'a6',
      textValue: '',
      key2: 'a',
      key2name: 'a',
    },
  ],
];
